import React, { useCallback, useState } from 'react';
import { Upload, message, Icon } from 'antd';

import { unzipSync, strFromU8 } from 'fflate';

import { BulkUploadButton } from '../TemplateSection/styles';
import { uploadDKVDesignXML, uploadImage } from '../../utils/services/uploadAPI';
import { createStandaloneBlock, fetchStandaloneBlock, translateStandaloneBlock, patchComplexBlock } from '../../utils/services/complexDocumentsAPI';
import { allMatchKey } from '../../utils/importHelper';
import { IMPORT_REUSABLE_PREFIX, DKV_CATEGORY, constructDesignFromInstructions } from './complexDocumentHelper';

const DEMO_PAYLOAD = {
     "categoryId": DKV_CATEGORY,
     "resourceGroupId": 40,
     "parentBlockName": "Sankari - testing reusable 4",
     "isReferenced": true,
     "blocks": [],
     "type": "content",
     "language": "en",
     "style": {
         "fontFamily": "Open Sans",
         "fontSize": 16
     }
 };

const getBlockPayloadFromPseudo = (zipFile, fileName, languageCode, imageMap = {}, block = true) => {
  console.log("Forming payload from :: ", fileName);
  const pseudoFileContents = strFromU8(zipFile[fileName]);
  if (pseudoFileContents.length === 0) {
    return;
  }
  let instructions = pseudoFileContents.split("\n").map((line, index) => {
    const tabs = line.includes('\t') ? line.split('\t').length - 1 : line.replaceAll('    ', '\t').split('\t').length - 1;
     return {
       tabs,
       instruction: line.replaceAll('\t', '').replaceAll('    ', '')
     };
   });
  console.log({ instructions });

  const designJSON = constructDesignFromInstructions(instructions, zipFile, true, languageCode, {}, imageMap);
  console.log({ documentDTO: designJSON });

  if (designJSON.flows[0] !== undefined && designJSON.flows[0].blocks.length > 0) {
    const blockName = designJSON.flows[0].flowName;
    if (block) {
      const payload = Object.assign({}, DEMO_PAYLOAD, {
        blocks: designJSON.flows[0].blocks.map(block => {
          delete block.blockId;
          return block;
        }),
        style: designJSON.style,
        language: designJSON.language,
        // Should be a unique name
        parentBlockName: `${IMPORT_REUSABLE_PREFIX} ${designJSON.flows[0].flowName}_en`,
        type: blockName.toLowerCase().startsWith('footer') ? 'footer' : 'content'
        // parentBlockName: "DKV IMPORT testing 2"
      });
      return payload;
    } else {
      const updatedDocument = {
        flows: designJSON.flows.map((flow, index) => {
          delete flow.flowId;
          return Object.assign({}, flow, {
            blocks: flow.blocks.map(block => {
              if (!block.isStandalone) {
                delete block.blockId; // Delete blockId only if it is not a standalone
              }
              return block;
            })
          });
        })
      };
      return updatedDocument;
    }
  }
  return null;
}

const DKVReusableImport = () => {

  const [loading, setLoading] = useState(false);

  /*const importTemplate = file => {
    const reader = new FileReader();
    reader.onload = onUploadXML;
    reader.readAsArrayBuffer(file);
  };*/

  const onUploadXML = useCallback(async (event) => {
    setLoading(true);

    // TODO : API to generate .zip file
    /*const response = {
      status: 200
    }*/
    console.log("Event :: ", event.name, event);
    const response = await uploadDKVDesignXML(event, event.name, false, 'sro');
    console.log({ response });

    if (response.status === 200) {
      // TODO : Extract zip file contents and obtain pseudo
      const arrayBuffer = await response.data.arrayBuffer();
      const zipFile = unzipSync(new Uint8Array(arrayBuffer));

      /*const zipFile = unzipSync(new Uint8Array(event.target.result), {
        filter(file) {
          // console.log({ file });
          return true;
        }
      });*/
      const pseudoFiles = allMatchKey(zipFile, '.txt', true);
      const imageFiles = allMatchKey(zipFile, '.txt', false);
      console.log({ zipFile, pseudoFiles, imageFiles });
      let uploaded = [];
      if (imageFiles.length > 0) {
        uploaded = await Promise.all(imageFiles.map((fileName) => {
          const file = new Blob([zipFile[fileName]], { type: 'image/jpeg' });
          return (async () => {
            let response = await uploadImage(file, `${IMPORT_REUSABLE_PREFIX} ${fileName.split('.')[0]}`);
            return {
              name: `${IMPORT_REUSABLE_PREFIX} ${fileName.split('.')[0]}`,
              link: response.imageLink
            };
          })();
        }));
      }
      const imageMap = uploaded.reduce((acc, image) => {
        return { ...acc,  [image.name]: image.link }
      }, []);
      console.log({ uploaded, imageMap });
      if (pseudoFiles.length > 0) {
        const pseudoFileName = 'en.txt';
        const payload = getBlockPayloadFromPseudo(zipFile, pseudoFileName, 'en', imageMap);
        if (!payload) return;
        const createResponse = await createStandaloneBlock(payload);
        console.log({ createResponse });

        // TODO : If there are any other languages, create the section with the same group ID
        if (pseudoFiles.length > 1 && createResponse?.statusCode === 2501) { // success
          const blockId = createResponse.data?.id;
          const pendingFiles = pseudoFiles.filter(name => name !== 'en.txt');
          console.log({ pendingFiles });

          // TODO : Recursive method impl
          pendingFiles.forEach(async (targetLangPseudo) => {
            const lang = targetLangPseudo.split('.txt')[0];
            const response = await translateStandaloneBlock({ documentId: blockId, languageCode: lang });

            if (response.data.id) {
              const patchPayload = getBlockPayloadFromPseudo(zipFile, targetLangPseudo, lang, imageMap, false);
              if (patchPayload && patchPayload.flows[0].blocks.length > 0) {
                patchPayload.documentId = response.data?.id;
                patchPayload.language = lang;
                patchPayload.type = payload.type;
                if (patchPayload) {
                  const patchResponse = await patchComplexBlock(patchPayload, false);
                  console.log({ patchResponse });
                }
              }
            }
          });
        }
      } else {
        message.error("No contents found for importing!!");
      }
    }

    if (response?.status !== 200) {
      message.error("Unable to generate design script!!");
    }

    setLoading(false);
  }, []);

  return (
    <Upload
      multiple={true}
      accept=".sro"
      // accept=".xml"
      showUploadList={false}
      className="dkvUpload"
      // action={importTemplate}
      action={onUploadXML}
    >
      <BulkUploadButton style={{ margin: 'auto', width: '50%' }}>
        <p className={'downloadZip'} style={{ visibility: loading ? 'visible' : 'hidden' }}>
          <Icon
            type={'loading'}
            style={{ marginRight: '5px', fontSize: '20px', color: '#FC6E51' }}
          />
        </p>
        <p className="import">
          {'Upload your SRO files'}
        </p>
        <p className="desc">
          {'We create the reusable sections for you so you can use them within DocStudio'}
        </p>
      </BulkUploadButton>
    </Upload>
  );
}

export default DKVReusableImport;